import { ListingStrategyRunStep } from '../../../../types/api'
import { APIError } from '../../../../components/products/types'

export interface Listing {
  active: boolean
  duration?: number
  binPrice?: number
  concurrentType?: 'SINGULAR' | 'CONCURRENT'
  marketId: number
  endTime?: Date
  paymentDeadline?: string
  externalErrors: any
  listingErrors: any
  projectedEndTime?: Date
  postType: 'auction' | 'fixed_price'
  previousId: number
  externalMarketId?: string
  listingId?: number
  bidCount?: number
  currentPrice?: number
  reservePrice?: number
  shippingPrice?: number
  startPrice?: number
  startTime?: Date
  viewCount?: number
  clickThroughRate?: number
  listingImpressionTotal?: number
  // TODO change this to all the state values, eg: LISTED | SOLD | PENDING | etc
  state: string
  currencyCode?: string
  marketAccountId?: number
  listingUrl?: string
  asin?: string
  marketAccount?: MarketAccountOnlyName
  accFullHumanReadableName?: string
}

export interface MarketAccountOnlyName {
  fullHumanReadableName: string
}

export interface RawProductListing {
  active: boolean
  createdAt: Date
  updatedAt: Date
  id: number
  listingId: number
  listingStrategyStepConfigurationId?: number
  listingType: string
  marketId: number
  previousId?: number
  price: string
  productId: number
  state: string
}

export interface ProjectedStep {
  step: ListingStrategyRunStep
  listings: Listing[]
  errors: APIError
}

export interface Channel {
  id: number
  name: string
  humanReadableName: string
}

export interface ListingByChannel {
  [channelId: number]: number
}

export const ChannelAction = {
  ADD: 'add',
  EDIT: 'edit',
  MOVE: 'move'
} as const

export type ChannelActionType = (typeof ChannelAction)[keyof typeof ChannelAction]

export interface ChannelActionInfo {
  actionType: ChannelActionType
  channelId: number
  description: string
  listingId?: number
  message?: string
}

export const ListingAction = {
  DELIST: 'delist',
  RELIST: 'relist',
  DELETE: 'delete',
  RECYCLE: 'recycle',
  LIST: 'list',
  ADD_ADDITIONAL_INFO: 'addAdditionalInfo'
} as const

export type ListingActionType = (typeof ListingAction)[keyof typeof ListingAction]

export interface ListingActionDialogType {
  actionType?: ListingActionType
  listing?: Listing
}

export interface ShopifyMarketAccountMeta {
  name: string
}

export interface ShopifyMarketAccount {
  id: any
  marketId: number
  meta: ShopifyMarketAccountMeta
}
